import {
  PublicService,
  ObserverService,
  ListingModalService,
  LessonService,
  ContentService,
} from "@DavisDigital/davisdigitalfrontend.module";
import { FolderTypes} from "@DavisDigital/interfaces";

class LessonCardController {

	public accountId: string; 
	public canEdit: boolean = false;
	public canDuplicate: boolean = false;
	public canSaveSample: boolean = false;
	public editUrl: string;

	public lesson: any;
	public lessonType: string;
	public archivedLesson:boolean = false;

	public lessonListing:any;
	public modalController:any;

	public title: string;
	public description: string;


	public imageUrl: string;
	public presentUrl: string;

	public slatwall:any;
	public folders:any;
	
	
	public isLoading = false;

	public superUser: boolean; 
	
	public pathToImage:string;

	public createdDateTime: string = "";
	public modifiedDateTime: string = "";
	public sharedBy : string = "";
	public shareText : string = "";
	
	// @ngInject
	constructor(
		public $filter			: ng.IFilterService,
		public publicService: PublicService,
		public observerService: ObserverService,
		private lessonService: LessonService,
		private contentService: ContentService,
		private listingModalService: ListingModalService
	) {}

	public $onInit = () => {
		this.mapMethodsFromLesson();
	}

	public onShare = () => {
	    this.listingModalService.launchShareSettingModal(this.title,this.lesson.lessonID,'lesson',"",Function,{}, this.lessonListing.davisAccountType != "Student");
	}
	
	public onExport = () => {
		
		var anchor = document.createElement('a');
        anchor.href = '?slatAction=davisdigital:api.exportLessons&apiData.lessonID=' + this.lesson.lessonID + '&apiData.downloadNowFlag=true';
        anchor.target = '_blank';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
	}
	
	public onArchive = () => {
	    this.listingModalService.launchArchiveModal(this.title,this.lesson.lessonID,'lesson', true, this.notifyRefreshLessonsAndFolders);
	}
	
	public onUnarchive = () => {
	    this.listingModalService.launchArchiveModal(this.title,this.lesson.lessonID,'lesson', false, this.notifyRefreshLessonsAndFolders);
	}
	
	public onDuplicate = () => {
		
		//Action type added to differentiate duplicate and save to my lesson action
		let actionType = "duplicate";
		if(this.lessonType == 'sample' && this.lesson.account_accountID != this.accountId) {
			actionType = "saveToMyLesson";
		}
		
	    this.listingModalService.launchDuplicateModal(this.lesson, null, (success) => {
	        if( success ){ this.notifyRefreshLessons(); }
	    }, actionType);
	}
	
	public onMove = (folderType) => {
	    this.listingModalService.launchMoveModal(this.title,this.lesson.lessonID, 'lesson', folderType , this.notifyRefreshLessonsAndFolders);
	}
	
	public onDelete = () => {
	    this.listingModalService.launchDeleteModal(
	        this.title,
	        this.lesson.lessonID,
	        'lesson',
	        (confirmDelete) => {
	            if(confirmDelete){
	            	if(this.lessonType == 'shared') {
		        		this.removeAccountAccess();
		        	} else {
		        		this.deleteLesson();
		        	}
	            } 
	        },
	        'lesson',
	        this.lessonType == 'shared' ? true : false,
	    );
	}

	private mapMethodsFromLesson = () => {
		this.title = this.lesson.title;
		this.presentUrl = `/lesson/?lessonID=${this.lesson.lessonID}&view=present`;
		this.editUrl = `/lesson-editor/?lessonID=${this.lesson.lessonID}&view=edit`;
		this.description = this.lesson.description;
		
		if( this.lesson.createdDateTime.trim() != "") {
			this.createdDateTime = this.$filter('date')(new Date(this.lesson.createdDateTime), "MM/dd/yyyy");
		}
		
		if( this.lesson.modifiedDateTime.trim() != "") {
			this.modifiedDateTime = this.$filter('date')(new Date(this.lesson.modifiedDateTime), "MM/dd/yyyy");
		}
		
		if( this.lesson.hasOwnProperty('accountAccess')) {
			this.sharedBy = this.lesson.accountAccess.createdByAccount?.firstName+" "+this.lesson.accountAccess.createdByAccount?.lastName;
			
			if(this.lesson.accountAccess.accountAccessType == "accountAccessWrite") {
				this.canEdit = true;
			}
			
			//user can duplicate if they have read access
			if(this.lesson.accountAccess.accountAccessType == "accountAccessRead") {
				this.canDuplicate = true;
			}
		}
		
		this.canEdit = ( this.lesson.lessonType_systemCode === 'ltSample' && this.superUser ) ||
					   ( this.lesson.account_accountID === this.accountId || this.superUser ) || (this.canEdit);
		
		//Let faculty / admin / super admin users to add lesson to "Save To My Lesson" action for sample lessons
		this.canSaveSample = ( this.lesson.lessonType_systemCode === 'ltSample' && (this.superUser || this.lessonListing.davisAccountType != "Student" ) );
		
		this.shareText = this.canEdit ? "Can Edit" : "Can View";
		
		//set archive lesson flag
		if( this.lesson.archiveFolder_folderID.trim() != "" ) {
			this.archivedLesson = true;
		}
		
		//user can duplicate if they've view access / have edit access / can save sample lesson & lesson is not archived
		this.canDuplicate = (this.canEdit || this.canDuplicate || this.canSaveSample) && !this.archivedLesson;
	}
	
	private removeAccountAccess = () =>{
	    this.isLoading = true;
	    this.contentService
        .removeAccountAccessForShare(this.lesson.lessonID)
        .then( result => {
			if( result?.successfulActions?.length ) {
			    this.notifyRefreshLessonsAndFolders();
			}
		});
		//TODO: success/errors
	}
	
	private deleteLesson = () =>{
	    this.isLoading = true;
	    
	    this.lessonService
        .deleteLesson(this.lesson.lessonID)
        .then( result => {
			if( result?.successfulActions?.length ) {
			    this.notifyRefreshLessonsAndFolders();
			}
		});
		//TODO: success/errors
	}
	
	private notifyRefreshLessons(){
	    this.lessonListing.getLessons(false,true);
	}
	
	private notifyRefreshLessonsAndFolders = () => {
	    this.lessonListing.refreshLessonsAndFolders(true,true);
	}
}

class LessonCard {

	public restrict: string = 'EA';
	public scope: boolean = true;

	public bindToController: any = {
		lesson: '=',
		lessonType:'=',
		lessonListing:'=',
		accountId:'@?',
		superUser:'=?',
		pathToImage:'@'
	};

	public controller = LessonCardController;
	public controllerAs = 'lessonCard';

	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/lesson-card.html';

	public static Factory() {
		return () => new this();
	}

}

export { LessonCard };
